import {
  DRAWER_LEASE_ADD,
  DRAWER_PAYMENT_RECURRING_PAYMENT,
} from "~/constants/general";

export const urlsThatNeedEmailVerification = [
  "/landlord/account-setup/stripe-onboarding/",
];

export const drawersThatNeedEmailVerification = [
  DRAWER_PAYMENT_RECURRING_PAYMENT,
  DRAWER_LEASE_ADD,
];
